export default "__VITE_ASSET__81aaf495__"